<template>
  <div>
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <h2 class="font-weight-bolder m-0">
        <span @click="$router.go(-1)">
          <b-button
            variant="white"
            class="btn-icon rounded-circle mr-50 text-primary bg-white"
          >
            <feather-icon icon="ChevronLeftIcon" />
          </b-button>
        </span> Perfil
      </h2>
    </div>
    <b-row>
      <b-col cols="12">
        <b-card class="height-card">
          <b-row class="mb-3">
            <b-col
              cols="12"
              class="d-flex align-items-center"
            >
              <div class="pr-2">
                <b-avatar
                  variant="dark"
                  size="6rem"
                  :src="user.avatar"
                />
              </div>
              <div class="d-flex align-items-center justify-content-between w-100">
                <div>
                  <h4 class="m-0 font-weight-bolder">
                    {{ user.name }} {{ user.surname }}
                  </h4>
                  <span
                    v-for="r in user.roles"
                    :key="r.display_name"
                    class="mr-1"
                  >
                    {{ r.display_name }}
                  </span>
                </div>
                <div
                  v-if="canModuleVacation && user.remaining_vacation_days !== undefined && user.used_vacation_days !== undefined"
                  class="vacation-balance-box d-flex flex-column align-items-end ml-2"
                >
                  <div class="vacation-balance-inner d-flex flex-column align-items-end">
                    <div class="d-flex align-items-center mb-1">
                      <feather-icon
                        icon="SunIcon"
                        size="18"
                        class="mr-1 text-warning"
                      />
                      <span
                        class="font-weight-bold text-muted"
                        style="font-size: 0.95rem;"
                      >Saldo de vacaciones</span>
                    </div>
                    <b-badge
                      variant="primary"
                      class="vacation-badge mb-1"
                    >
                      {{ user.used_vacation_days }}/{{ user.annual_vacation_days }}
                      <span style="font-weight: 400; font-size: 0.92rem;">días pendientes</span>
                    </b-badge>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="position-relative">
            <b-col
              v-if="user.job"
              xl="3"
              md="6"
            >
              <p class="mb-50 title-style">
                PUESTO DE TRABAJO
              </p>
              <p class="font-weight-bolder">
                {{ user.job }}
              </p>
            </b-col>
            <b-col
              v-if="user.departments && user.departments.length"
              xl="3"
              md="6"
            >
              <p class="mb-50 title-style">
                DEPARTAMENTOS
              </p>
              <p class="font-weight-bolder">
                <span
                  v-for="(d, i) in user.departments"
                  :key="d.name"
                ><span v-if="i !== 0">, </span>{{ d.name }}</span>
              </p>
            </b-col>
            <b-col
              v-if="user.username"
              xl="3"
              md="6"
            >
              <p class="mb-50 title-style">
                USUARIO
              </p>
              <p class="font-weight-bolder">
                {{ user.username }}
              </p>
            </b-col>
            <b-col
              v-if="user.email"
              xl="3"
              md="6"
            >
              <p class="mb-50 title-style">
                EMAIL
              </p>
              <p class="font-weight-bolder">
                {{ user.email }}
              </p>
            </b-col>
            <b-col
              v-if="user.phone && user.phone !== 'null'"
              xl="3"
              md="6"
            >
              <p class="mb-50 title-style">
                TELÉFONO
              </p>
              <p class="font-weight-bolder">
                {{ user.phone }}
              </p>
            </b-col>
            <b-col
              cols="12"
              class="text-right"
            >
              <b-link
                :to="{ name: 'editUser', params: { id: user.id} }"
                class="d-inline-block text-dark pt-2"
              >
                <span class="">Editar</span>
                <span class=" pl-1"><feather-icon icon="Edit2Icon" /></span>
              </b-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <Partes
      v-if="userPrepare"
      :user="user"
    />
    <UserAbsencesRequests
      v-if="userPrepare"
      :user-id="user.id"
    />
    <Documents
      v-if="(role == 'super_admin' || role == 'admin') && canModuleDocuments"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import {
  BButton, BAvatar, BRow, BCol, BCard, BLink, BBadge,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import Partes from '@/views/partes/Listado.vue'
import Documents from '@/views/documents/viewUser.vue'
import UserAbsencesRequests from '@/views/absences/UserAbsencesRequests.vue'

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BCard,
    BBadge,
    BLink,
    Partes,
    Documents,
    UserAbsencesRequests,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      id: this.$route.params.id,
      companies: '',
      departments: [],
      files: [],
      profileFile: null,
      required,
      email,
      userPrepare: false,
      changePassword: false,
      collapseInfo: false,
      canModuleDocuments: localStorage.getItem('canModuleDocuments') === 'true',
      canModuleVacation: localStorage.getItem('canModuleVacation') === 'true',
    }
  },
  computed: {
    ...mapGetters({
      user: 'users/getUser',
      role: 'auth/getRole',
      checkJourney: 'users/getCheckJourney',
      currentClient: 'clients/getCurrentClient',
    }),
  },
  methods: {
    ...mapActions({
      getUser: 'users/getUser',
      getCheckJourney: 'users/checkJourney',
      restartJourney: 'users/restartJourney',
    }),
    ...mapMutations({
      setSelectDepartments: 'departments/setSelectDepartments',
    }),
    setClients() {
      if (this.user.clients) {
        this.clients = this.user.clients
      }
    },
    setDepartments() {
      if (this.user.departments && this.user.departments[0]) {
        this.user.departments.forEach(element => {
          this.departments.push(element.id)
        })
      }
    },
  },
  async created() {
    await this.getUser(this.$route.params.id)
    await this.setDepartments()
    await this.getCheckJourney({ user: this.$route.params.id })
    this.userPrepare = true
  },
}
</script>

<style scoped>
.vacation-balance-inner {
  border-radius: 1rem;
  padding: 0.75rem 1.25rem;
  min-width: 180px;
  box-shadow: none;
  background: none;
}
.vacation-badge {
  font-size: 1.05rem;
  padding: 0.45em 1em;
  border-radius: 0.7em;
  font-weight: 600;
}
</style>
